import type { Role } from './api/types'

/**
 * Az RBAC mátrix kódolt változata — a docs/07-security.md 7.12 szekció szerinti.
 * Server-side is ezt érvényesíti; a UI csak elrejt / disable-el.
 */

export type PermissionKey =
  | 'invoices.list'
  | 'invoices.read'
  | 'invoices.upload'
  | 'invoices.changeStatus'
  | 'invoices.approve'
  | 'invoices.approveOverLimit'
  | 'invoices.archive'
  | 'invoices.manualMatch'
  | 'matching.run'
  | 'ingestion.emailSync'
  | 'ingestion.navSync'
  | 'export.generate'
  | 'export.approve'
  | 'export.approveOverLimit'
  | 'export.send'
  | 'settings.nav'
  | 'settings.email'
  | 'settings.approvals'
  | 'settings.users'
  | 'auditLog.read'

const TABLE: Record<PermissionKey, Role[]> = {
  'invoices.list': ['admin', 'company_owner', 'finance_manager', 'employee_uploader', 'accountant', 'readonly_auditor'],
  'invoices.read': ['admin', 'company_owner', 'finance_manager', 'employee_uploader', 'accountant', 'readonly_auditor'],
  'invoices.upload': ['admin', 'company_owner', 'finance_manager', 'employee_uploader'],
  'invoices.changeStatus': ['admin', 'company_owner', 'finance_manager'],
  'invoices.approve': ['admin', 'company_owner', 'finance_manager'],
  'invoices.approveOverLimit': ['admin', 'company_owner'],
  'invoices.archive': ['admin', 'company_owner', 'finance_manager'],
  'invoices.manualMatch': ['admin', 'company_owner', 'finance_manager'],
  'matching.run': ['admin', 'company_owner', 'finance_manager'],
  'ingestion.emailSync': ['admin', 'company_owner', 'finance_manager'],
  'ingestion.navSync': ['admin', 'company_owner', 'finance_manager'],
  'export.generate': ['admin', 'company_owner', 'finance_manager'],
  'export.approve': ['admin', 'company_owner', 'finance_manager'],
  'export.approveOverLimit': ['admin', 'company_owner'],
  'export.send': ['admin', 'company_owner', 'finance_manager'],
  'settings.nav': ['admin', 'company_owner'],
  'settings.email': ['admin', 'company_owner'],
  'settings.approvals': ['admin', 'company_owner'],
  'settings.users': ['admin', 'company_owner'],
  'auditLog.read': ['admin', 'company_owner', 'finance_manager', 'readonly_auditor'],
}

export function hasPermission(role: Role | null, perm: PermissionKey): boolean {
  if (!role) return false
  return TABLE[perm].includes(role)
}

/** Az `employee_uploader` csak saját feltöltéseit látja — szűrési helper. */
export function canSeeInvoice(opts: {
  role: Role | null
  uploadedByUserId: string | null
  currentUserId: string | null
}): boolean {
  if (!opts.role) return false
  if (opts.role === 'employee_uploader') {
    return opts.uploadedByUserId === opts.currentUserId
  }
  return true
}
